// Telas onde o board de fluxos precisa economizar espaço: notebook 1366x768,
// 1440x900 e 1920x1080 com zoom 125% do Windows (viewport 1536x864, ~730px de
// altura útil no navegador). Largura OU altura pequena ativa o modo compacto;
// 1920x1080 em 100% (viewport ~1920x950) fica fora.
//
// Chave de makeStyles, igual ao que theme.breakpoints.down() gera:
//   [KANBAN_COMPACT_MQ]: { ... }
// Compartilhada por KanbanBoard/index.js, KanbanColumn.js e KanbanCard.js para
// os três apertarem juntos — meia coluna compacta com card largo fica pior que
// nenhum dos dois.
export const KANBAN_COMPACT_MQ =
  "@media (max-width: 1599.95px), (max-height: 819.95px)";
